/**
 * Directives
 * Register Angular directives for Dashboards
 *
 * @package:  frictionlessdigital/dashboard
 * @version:  2.7
 * @author:   Cyrill N KALITA
 */

require('./highChart.js');
require('./halfPieChart.js');
